import React from 'react';
import { Helmet } from 'react-helmet';

/* eslint-disable react/prop-types */
const Header = ({ shopName }) => (
  <div className="u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center">
    <Helmet>
      <title>Loyalty Program | {shopName}</title>
    </Helmet>
    You are half way to reaching your rewards under our loyalty program in {shopName}.
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerLoyaltyUpdate/components/Header.jsx